// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fastClick from 'fastclick' // 300毫秒延迟
import VueAwesomeSwiper from 'vue-awesome-swiper' // 轮播图
import axios from './http'
import store from './store/store'
import 'swiper/dist/css/swiper.css'
// 重置CSS
import './assets/styles/reset.css'
// 1像素边框
import './assets/styles/border.css'
// iconfont
import './assets/styles/iconfont.css'
// 引入编辑器样式
import './assets/styles/font-awesome.min.css'
// 引入QS
import qs from 'qs'
// 引入vueg
import vueg from 'vueg'
import 'vueg/css/transition-min.css'
// 引入mint
import 'mint-ui/lib/style.css'
import { Indicator } from 'mint-ui'
// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入VueHtml5Editor编辑器
import VueHtml5Editor from 'vue-html5-editor'
const options = {
  duration: '0.3', // 转场动画时长，默认为0.3，单位秒
  firstEntryDisable: false, // 值为true时禁用首次进入应用时的渐现动画，默认为false
  firstEntryDuration: '.6', // 首次进入应用时的渐现动画时长，默认为.6
  forwardAnim: 'fadeInRight', // 前进动画，默认为fadeInRight
  backAnim: 'fadeInLeft', // 后退动画，默认为fedeInLeft
  sameDepthDisable: false, // url深度相同时禁用动画，默认为false
  tabsDisable: false, // 值为true时，tabs间的转场没有动画，默认为false
  disable: false, // 禁用转场动画，默认为false，嵌套路由默认为true
  shadow: false // 为false，转场时没有阴影层次效果
}
Vue.use(vueg, router, options)
Vue.config.productionTip = false
Vue.prototype.bus = new Vue()
fastClick.attach(document.body)
Vue.use(VueAwesomeSwiper)
// 将axios挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.prototype.axios = axios
Vue.prototype.$qs = qs
Vue.component(Indicator)
Vue.use(ElementUI)
Vue.use(VueHtml5Editor, {
  showModuleName: true,
  image: {
    sizeLimit: 1024 * 1024,
    compress: true,
    width: 500,
    height: 500,
    quality: 80
  },
  language: 'zh-cn'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js